import { featured, hotRank, leadStory, hotKeywords } from "@/mocks/gossip";

export default function FirstScreen() {
  return (
    <section id="top" className="mx-auto max-w-[1400px] px-4 md:px-6">
      {/* 头条大图 + 热度榜 */}
      <div className="grid gap-6 lg:grid-cols-3">
        {/* 主推头版 */}
        <article className="group relative overflow-hidden rounded-lg lg:col-span-2">
          <div className="relative h-[340px] w-full overflow-hidden sm:h-[440px] md:h-[520px]">
            <img
              src={leadStory.img}
              alt={leadStory.title}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-black/10" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
              <div className="mb-3 flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded bg-primary-500 px-2 py-1 text-xs font-bold text-foreground-50">
                  <i className="ri-flashlight-fill" /> 全网独家
                </span>
                <span className="rounded bg-black/40 px-2 py-1 text-xs font-medium text-white backdrop-blur">{leadStory.tag}</span>
              </div>
              <a href="#archive" className="font-heading block max-w-3xl text-2xl font-black leading-tight text-white transition-colors group-hover:text-primary-200 md:text-4xl">
                {leadStory.title}
              </a>
              <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-white/80 md:block">{leadStory.intro}</p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-white/70">
                {leadStory.meta.map((m) => (
                  <span key={m} className="inline-flex items-center gap-1"><i className="ri-time-line" />{m}</span>
                ))}
              </div>
            </div>
          </div>
        </article>

        {/* 热度榜侧栏 */}
        <aside className="flex flex-col rounded-lg border border-foreground-200/60 bg-background-100/60">
          <div className="flex items-center justify-between border-b border-foreground-200/60 px-4 py-3">
            <h3 className="font-heading flex items-center gap-2 text-lg font-black text-foreground-950">
              <i className="ri-fire-fill text-primary-500" /> 今日热度榜
            </h3>
            <span className="whitespace-nowrap text-xs text-foreground-500">每 5 分钟更新</span>
          </div>
          <ol className="flex-1 divide-y divide-foreground-200/60">
            {hotRank.map((h) => (
              <li key={h.rank}>
                <a href="#rank" className="flex items-center gap-3 px-4 py-2.5 transition-colors hover:bg-background-50">
                  <span
                    className={
                      "flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold " +
                      (h.rank <= 3 ? "bg-primary-500 text-foreground-50" : "bg-secondary-200 text-secondary-900")
                    }
                  >
                    {h.rank}
                  </span>
                  <span className="flex-1">
                    <span className="line-clamp-1 text-sm font-medium text-foreground-900">{h.title}</span>
                    <span className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className={h.up ? "ri-arrow-up-line text-primary-600" : "ri-arrow-down-line text-accent-600"} />
                        {h.heat}
                      </span>
                      <span className="hidden sm:inline">{h.delta}</span>
                    </span>
                  </span>
                </a>
              </li>
            ))}
          </ol>
          <a href="#rank" className="flex items-center justify-center gap-1 border-t border-foreground-200/60 py-3 text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600">
            查看完整热度榜 <i className="ri-arrow-right-line" />
          </a>
        </aside>
      </div>

      {/* 多卡并列首屏 */}
      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {featured.map((c, i) => (
          <article key={c.title} className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/60 bg-background-100/50 transition-transform duration-300 hover:-translate-y-1">
            <div className="relative h-48 w-full overflow-hidden">
              <img src={c.img} alt={c.title} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded bg-black/45 px-2 py-1 text-[11px] font-bold text-white backdrop-blur">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="absolute right-3 top-3 rounded bg-primary-500 px-2 py-1 text-[11px] font-bold text-foreground-50">{c.tag}</span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <a href="#feed" className="font-heading line-clamp-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {c.title}
              </a>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span className="whitespace-nowrap">{c.time}</span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-fire-line text-primary-500" />{c.heat}</span>
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* 关键词云 */}
      <div className="mt-6 flex flex-wrap items-center gap-2 rounded-lg border border-foreground-200/60 bg-background-100/50 px-4 py-3">
        <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-foreground-900">
          <i className="ri-price-tag-3-line text-primary-500" /> 实时热词
        </span>
        {hotKeywords.map((k) => (
          <a key={k} href="#feed" className="whitespace-nowrap rounded-full border border-foreground-300/60 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700">
            {k}
          </a>
        ))}
      </div>
    </section>
  );
}